import { Button, Card, EmptyState } from '@tessma/design-system';

/**
 * The pages Stage 2 has.
 *
 * One generic landing page, one sign-in screen, and the two refusals. Stage 2
 * builds no business-module pages — a Finance screen would be Finance, and
 * Finance has not started — so every entitled module lands on the same honest
 * page rather than on invented content.
 */

export function ModuleLanding({ label }: { readonly label: string }) {
  return (
    <Card>
      <EmptyState
        icon="squares-four"
        title={`${label} is available to this tenant`}
        description={
          'Platform Core is in place: tenancy, identity, authorisation, audit and entitlement. ' +
          'This module is entitled and reachable; its screens are built in a later stage.'
        }
      />
    </Card>
  );
}

export function SignInPage({
  onSignIn,
  pending,
}: {
  readonly onSignIn: () => void;
  readonly pending: boolean;
}) {
  return (
    <main className="signIn">
      {/*
        On a Card rather than directly on the workspace ground. Secondary text
        on the workspace reaches 4.47:1, just under the 4.5:1 the WCAG 2.2 AA
        threshold requires at this size; on the surface token it reaches 4.76:1.
        Found by the accessibility gate, fixed by using the system correctly
        rather than by lowering the threshold or inventing a darker grey.
      */}
      <Card>
        <h1>TESSMA ONE</h1>
        <p>
          Sign in with your organisation account. TESSMA ONE never asks for your password: it
          redirects you to your identity provider and receives only the result.
        </p>
        <Button onClick={onSignIn} disabled={pending}>
          {pending ? 'Redirecting…' : 'Sign in'}
        </Button>
      </Card>
    </main>
  );
}

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState
        icon="magnifying-glass"
        title="Not found"
        description="There is nothing at this address for your account."
      />
    </Card>
  );
}

export function ForbiddenPage() {
  return (
    <Card>
      <EmptyState
        icon="lock-simple"
        title="You do not have permission for this"
        description={
          'Your account is signed in, but it does not hold the permission this screen requires. ' +
          'Ask an administrator in your organisation if you need it.'
        }
      />
    </Card>
  );
}
